import { GraphQLClient } from "graphql-request";
import { createContext } from "react";

type ClientStore = Map<string, [string, GraphQLClient]>;

const GraphqlClientContext = createContext<ClientStore>(new Map());

export default GraphqlClientContext;
